import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.modals.data.promotion_deposit_bonus,
    ({button}) => {
        return {
            button
        }
    }
)